import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of as observableOf } from 'rxjs';
import { catchError, map, mapTo, startWith, switchMap } from 'rxjs/operators';
import { AbstractSelfDiagnosticApiService } from 'src/app/core/services/abstract/abstract-self-diagnostic-api-service';
import * as actions from './actions';

@Injectable()
export class SearchServiceEffects {
  private service = inject(AbstractSelfDiagnosticApiService);
  private actions$ = inject(Actions);

  searchRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.SearchRequestAction>(actions.ActionTypes.SEARCH_REQUEST),
      switchMap(action =>
        this.service.searchService(action.searchString).pipe(
          map(response =>
            response.isSucceeded ? new actions.SearchSuccessAction(response.result) : new actions.FailureAction(response.errors[0])
          ),
          catchError(error => observableOf(new actions.FailureAction(error)))
        )
      )
    )
  );

  setSelectedRequestEffect$: Observable<Action> = createEffect(() =>
    this.actions$.pipe(
      ofType<actions.SetSelectedRequestAction>(actions.ActionTypes.SET_SELECTED_REQUEST),
      switchMap(action => observableOf(new actions.SetSelectedSuccessAction(action.model)))
    )
  );
}
